export default "__VITE_ASSET__548b4d33__"